export const INIT_FETCH_HISTORIC_DATA = 'INIT_FETCH_DATA';
export const FETCH_HISTORIC_DATA_START = 'FETCH_HISTORIC_DATA_START';
export const FETCH_HISTORIC_DATA_SUCCESS = 'FETCH_HISTORIC_DATA_SUCCESS';
export const FETCH_HISTORIC_DATA_FAILED = 'FETCH_HISTORIC_DATA_FAILED';

export const INIT_FETCH_USECASE_DATA = 'INIT_FETCH_USECASE_DATA';
export const FETCH_USECASE_DATA_START = 'FETCH_USECASE_DATA_START';
export const FETCH_USECASE_DATA_SUCCESS = 'FETCH_USECASE_DATA_SUCCESS';
export const FETCH_USECASE_DATA_FAILED = 'FETCH_USECASE_DATA_FAILED';

export const INIT_FETCH_LIVE_DATA = 'INIT_FETCH_LIVE_DATA';
export const FETCH_LIVE_DATA_START = 'FETCH_LIVE_DATA_START';
export const FETCH_LIVE_DATA_SUCCESS = 'FETCH_LIVE_DATA_SUCCESS';
export const FETCH_LIVE_DATA_FAILED = 'FETCH_LIVE_DATA_FAILED';

export const INIT_UPDATE_USECASE = 'INIT_UPDATE_USECASE';
export const UPDATE_USECASE_START = 'UPDATE_USECASE_START';
export const UPDATE_USECASE_SUCCESS = 'UPDATE_USECASE_SUCCESS';
export const UPDATE_USECASE_FAILED = 'UPDATE_USECASE_FAILED';

export const INIT_FETCH_ARDUINO_DATA = 'INIT_FETCH_ARDUINO_DATA';
export const FETCH_ARDUINO_DATA_START = 'FETCH_ARDUINO_DATA_START';
export const FETCH_ARDUINO_DATA_SUCCESS = 'FETCH_ARDUINO_DATA_SUCCESS';
export const FETCH_ARDUINO_DATA_FAILED = 'FETCH_ARDUINO_DATA_FAILED';

export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_ROLE = 'AUTH ROLE';
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT';
export const AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const INIT_FETCH_USERS_DATA = 'INIT_FETCH_USERS_DATA';
export const FETCH_USERS_DATA_START = 'FETCH_USERS_DATA_START';
export const FETCH_USERS_DATA_SUCCESS = 'FETCH_USERS_DATA_SUCCESS';
export const FETCH_USERS_DATA_FAILED = 'FETCH_USERS_DATA_FAILED';

export const FETCH_SENSORS_DATA_INIT = 'FETCH_SENSORS_DATA_INIT';
export const INIT_FETCH_SENSORS_DATA = 'INIT_FETCH_SENSORS_DATA';
export const FETCH_SENSORS_DATA_START = 'FETCH_SENSORS_DATA_START';
export const FETCH_SENSORS_DATA_SUCCESS = 'FETCH_SENSORS_DATA_SUCCESS';
export const FETCH_SENSORS_DATA_FAILED = 'FETCH_SENSORS_DATA_FAILED';

export const INIT_SUBMIT_SETTINGS = 'INIT_SUBMIT_SETTINGS';
export const SUBMIT_SETTINGS_START = 'SUBMIT_SETTINGS_START';
export const SUBMIT_SETTINGS_SUCCESS ='SUBMIT_SETTINGS_SUCCESS';
export const SUBMIT_SETTINGS_FAIL ='SUBMIT_SETTINGS_FAIL';
export const SUBMIT_SETTINGS_INIT = 'SUBMIT_SETTINGS_INIT';

export const INIT_CREATE_USECASE = 'INIT_CREATE_USECASE';
export const CREATE_USECASE_START = 'CREATE_USECASE_START';
export const CREATE_USECASE_SUCCESS ='CREATE_USECASE_SUCCESS';
export const CREATE_USECASE_FAIL ='CREATE_USECASE_FAIL';
export const CREATE_USECASE_INIT = 'CREATE_USECASE_INIT';

export const INIT_DELETE_USECASE = 'INIT_DELETE_USECASE';
export const DELETE_USECASE_START = 'DELETE_USECASE_START';
export const DELETE_USECASE_SUCCESS ='DELETE_USECASE_SUCCESS';
export const DELETE_USECASE_FAIL ='DELETE_USECASE_FAIL';
export const DELETE_USECASE_INIT = 'DELETE_USECASE_INIT';

export const CREATE_USER_SUCCESS ='CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL ='CREATE_USER_FAIL';

export const INIT_UPDATE_PROFILE = 'INIT_UPDATE_PROFILE';
export const UPDATE_PROFILE_START = 'UPDATE_PROFILE_START';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED';

export const INIT_DELETE_USER = 'INIT_DELETE_USER';
export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_SUCCESS ='DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL ='DELETE_USER_FAIL';

export const INIT_POST_MESSAGE = 'INIT_POST_MESSAGE';
export const POST_MESSAGE_START = 'POST_MESSAGE_START';
export const POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
export const POST_MESSAGE_FAILED = 'POST_MESSAGE_FAILED';
